const ErrorPage = () => {
  return <div></div>;
};

export default ErrorPage;
